module.exports = __webpack_public_path__ + "static/customer-testimonial-bg-5-mobile-9217561db101ddab4033906acc001c7c.png";